module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-quote-fill-98d3524c.svg";